<div class="d-flex justify-content-center align-items-center">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-220 -220 200 150"
    width="200"
    height="140"
    preserveAspectRatio="xMidYMid meet">
    <defs>
      <linearGradient
        id="paint0_linear_23_7"
        x1="0.04"
        y1="55.6383"
        x2="164.06"
        y2="55.6383"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(1, 0, 0, 1, -161.806261, -159.449921)">
        <stop stop-color="#C80A00"></stop>
        <stop
          offset="1"
          stop-color="#F0370A"></stop>
      </linearGradient>
      <linearGradient
        id="paint0_linear_25_21"
        x1="-87.96"
        y1="10.6428"
        x2="76.06"
        y2="10.6428"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(1, 0, 0, 1, -74.763743, -164.287657)">
        <stop stop-color="#C80A00"></stop>
        <stop
          offset="1"
          stop-color="#F0370A"></stop>
      </linearGradient>
      <linearGradient
        id="paint0_linear_25_15"
        x1="-43.66"
        y1="33.4383"
        x2="120.36"
        y2="33.4383"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(1, 0, 0, 1, -117.913259, -137.191328)">
        <stop stop-color="#C80A00"></stop>
        <stop
          offset="1"
          stop-color="#F0370A"></stop>
      </linearGradient>
      <linearGradient
        id="paint0_linear_25_18"
        x1="-87.96"
        y1="10.6428"
        x2="76.06"
        y2="10.6428"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(1, 0, 0, 1, -73.805841, -114.583435)">
        <stop stop-color="#C80A00"></stop>
        <stop
          offset="1"
          stop-color="#F0370A"></stop>
      </linearGradient>
    </defs>
    <g
      id="object-4"
      transform="matrix(1, 0, 0, 1, 0, 5.684341886080802e-14)">
      <g>
        <g
          style=""
          id="object-0"
          transform="matrix(1, 0, 0, 1, -39.938065, -48.924129)">
          <path
            d="M -122.2 -118.71 L -148.2 -132.71 L -158.2 -138.21 L -158.7 -139.71 L -157.7 -141.71 L -130.2 -156.71 L -123.2 -158.71 L -120.2 -157.71 L -90.7 -143.21 L -87.7 -140.21 L -87.7 -138.71 L -122.2 -118.71 Z"
            fill="#F2F2F2"
            style=""></path>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M -85.606 -135.93 C -85.778 -118.99 -85.484 -126.92 -85.603 -117.2 C -84.534 -115.67 -117.96 -95.501 -118.1 -95.431 C -118.1 -95.431 -121.5 -94.229 -123.4 -94.129 C -125.3 -94.029 -127.2 -94.329 -128.8 -95.131 L -158.8 -104.53 C -159.6 -104.93 -160.2 -105.43 -160.7 -106.03 C -161.5 -106.93 -161.8 -107.93 -161.8 -108.93 L -161.6 -138.33 C -161.6 -138.63 -161.6 -138.93 -161.6 -139.13 C -161.4 -140.13 -160.9 -141.03 -160.3 -141.73 C -159.6 -142.53 -158.7 -143.13 -157.8 -143.63 L -129.5 -158.03 C -128 -158.83 -126 -159.33 -124 -159.43 C -122.1 -159.53 -120.2 -159.23 -118.6 -158.43 L -88.606 -143.23 C -87.806 -142.83 -87.206 -142.33 -86.706 -141.73 C -85.906 -140.83 -85.606 -139.83 -85.606 -138.83 L -85.606 -135.93 Z M -120.4 -155.53 C -122.4 -156.53 -125.8 -156.03 -127.7 -155.13 L -156 -140.73 C -157.2 -140.13 -158.7 -138.83 -156.8 -137.93 L -126.8 -122.73 C -124.8 -121.73 -121.4 -122.13 -119.5 -123.13 L -91.205 -137.53 C -90.006 -138.13 -88.506 -139.43 -90.406 -140.33 L -120.4 -155.53 Z"
            fill="url(#paint0_linear_23_7)"
            style=""></path>
          <animateMotion
            id="down"
            begin="0.03s; down.end + 0.5s"
            repeatCount="1"
            path="M 0 0 L -0.032 33.19"
            calcMode="linear"
            dur="0.26s"
            fill="freeze"
            keyTimes="0; 0.52763; 1"
            keyPoints="0; 0.55; 0"></animateMotion>
          <animate
            attributeName="opacity"
            values="1; 1"
            begin="1.36s"
            dur="0.07s"
            fill="freeze"></animate>
        </g>
        <g
          style=""
          id="object-1"
          transform="matrix(1, 0, 0, 1, -39.938065, -48.924129)">
          <path
            d="M -35.49 -122.99 L -61.49 -136.99 L -71.49 -142.49 L -71.99 -143.99 L -70.99 -145.99 L -43.49 -160.99 L -36.49 -162.99 L -33.494 -161.99 L -3.994 -147.49 L -0.994 -144.49 L -0.994 -142.99 L -35.49 -122.99 Z"
            fill="#F2F2F2"
            style=""></path>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M -74.764 -119.97 L -74.654 -142.4 L -74.579 -143.84 C -74.579 -143.84 -73.697 -145.676 -73.041 -146.596 C -72.4 -147.496 -70.055 -148.649 -70.055 -148.649 L -41.793 -163.046 C -41.793 -163.046 -37.567 -164.218 -35.862 -164.014 C -33.594 -163.743 -31.417 -162.779 -31.417 -162.779 L -1.664 -148.27 C -0.864 -147.87 -0.264 -147.37 0.236 -146.77 C 1.036 -145.87 1.336 -144.87 1.336 -143.87 L 1.236 -116.507 C 1.236 -116.207 0.706 -114.569 0.106 -113.869 C -0.594 -113.069 -2.16 -112.05 -2.96 -111.55 L -31.868 -97.666 C -33.368 -96.866 -37.019 -96.941 -39.019 -96.841 C -40.919 -96.741 -44.182 -97.615 -45.782 -98.415 L -71.764 -115.57 C -72.564 -115.97 -73.164 -116.47 -73.664 -117.07 C -74.464 -117.97 -74.764 -118.97 -74.764 -119.97 Z M -40.764 -160.07 L -69.064 -145.67 C -70.264 -145.07 -71.764 -143.77 -69.864 -142.87 L -39.864 -127.67 C -37.864 -126.67 -34.464 -127.07 -32.564 -128.07 L -4.264 -142.47 C -3.064 -143.07 -1.564 -144.37 -3.464 -145.27 L -33.464 -160.47 C -35.364 -161.47 -38.864 -161.07 -40.764 -160.07 Z"
            fill="url(#paint0_linear_25_21)"
            style=""></path>

          <animateMotion
            id="left"
            begin="0.58s; left.end + 0.5s"
            repeatCount="1"
            path="M 0 0 L -0.032 27.198"
            calcMode="linear"
            dur="0.17s"
            fill="freeze"
            keyTimes="0; 0.50992; 1"
            keyPoints="0; 0.509921; 0"></animateMotion>
          <animate
            attributeName="opacity"
            values="1; 1"
            begin="1.36s"
            dur="0.07s"
            fill="freeze"></animate>
        </g>
        <g
          style=""
          id="object-2"
          transform="matrix(1, 0, 0, 1, -39.938065, -48.924129)">
          <path
            d="M -79.234 -95.649 L -105.23 -109.65 L -115.23 -115.15 L -115.73 -116.65 L -114.73 -118.65 L -87.234 -133.65 L -80.234 -135.65 L -77.234 -134.65 L -47.734 -120.15 L -44.734 -117.15 L -44.734 -115.65 L -79.234 -95.649 Z"
            fill="#F2F2F2"
            style=""></path>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M -74.513 -136.08 L -44.051 -120.41 C -43.801 -119.99 -42.875 -119.73 -42.785 -118.14 C -42.548 -113.97 -42.648 -99.25 -42.481 -95.847 C -42.458 -95.375 -42.595 -95.092 -42.56 -95.115 L -43.371 -94.474 L -73.613 -73.672 L -74.113 -73.372 C -75.613 -72.572 -77.613 -72.072 -79.613 -71.972 C -81.513 -71.872 -83.413 -72.172 -85.013 -72.972 L -114.91 -88.072 C -115.71 -88.472 -116.31 -88.972 -116.81 -89.572 C -117.61 -90.472 -117.91 -91.472 -117.91 -92.472 C -117.91 -92.472 -117.83 -108.3 -117.8 -115.28 C -117.78 -117.4 -116.48 -118.84 -116.48 -118.84 C -115.99 -119.41 -113.63 -120.71 -114.1 -120.47 L -85.413 -135.88 C -83.913 -136.58 -82.013 -137.08 -80.113 -137.18 C -78.213 -137.28 -76.313 -136.98 -74.713 -136.18 L -74.513 -136.08 Z M -75.713 -100.77 L -47.413 -115.18 C -46.213 -115.78 -44.713 -117.08 -46.613 -117.98 L -76.613 -133.18 C -78.613 -134.18 -82.013 -133.68 -83.913 -132.78 L -112.21 -118.38 C -113.41 -117.78 -114.91 -116.48 -113.01 -115.58 L -83.013 -100.37 C -81.113 -99.37 -77.713 -99.77 -75.713 -100.77 Z"
            fill="url(#paint0_linear_25_15)"
            style=""></path>
          <animateMotion
            id="down"
            begin="0.2s; down.end + 0.5s"
            repeatCount="1"
            path="M 0 0 L -0.493 28.12"
            calcMode="linear"
            dur="0.17s"
            fill="freeze"
            keyTimes="0; 0.512038; 1"
            keyPoints="0; 0.7; 0"></animateMotion>
          <animate
            attributeName="opacity"
            values="1; 1"
            begin="1.38s"
            dur="0.05s"
            fill="freeze"></animate>
        </g>
        <g
          id="object-3"
          transform="matrix(1, 0, 0, 1, -39.938065, -48.924129)">
          <path
            d="M -34.301 -73.305 L -60.301 -87.305 L -70.301 -92.805 L -70.801 -94.305 L -69.801 -96.305 L -42.301 -111.3 L -35.301 -113.3 L -32.305 -112.3 L -2.805 -97.805 L 0.195 -94.805 L 0.195 -93.305 L -34.301 -73.305 Z"
            fill="#F2F2F2"
            style=""></path>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M -73.806 -70.26 L -73.696 -92.691 L -73.621 -94.135 C -73.621 -94.135 -73.165 -96.44 -72.509 -97.36 C -71.868 -98.26 -69.95 -99.46 -69.95 -99.46 L -41.229 -113.77 C -41.229 -113.77 -38.107 -114.6 -36.402 -114.58 C -34.118 -114.57 -30.427 -112.95 -30.427 -112.95 L -0.706 -98.56 C 0.094 -98.16 0.694 -97.66 1.194 -97.06 C 1.994 -96.16 2.294 -95.16 2.294 -94.16 L 2.194 -64.86 C 2.194 -64.56 2.194 -64.36 2.094 -64.06 C 1.894 -63.06 1.394 -62.16 0.794 -61.46 C 0.094 -60.66 -0.806 -60.06 -1.606 -59.56 L -29.906 -45.16 C -31.406 -44.36 -33.406 -43.86 -35.406 -43.76 C -37.306 -43.66 -39.206 -43.96 -40.806 -44.76 L -70.806 -65.86 C -71.606 -66.26 -72.206 -66.76 -72.706 -67.36 C -73.506 -68.26 -73.806 -69.26 -73.806 -70.26 Z M -39.806 -110.36 L -68.106 -95.96 C -69.306 -95.36 -70.806 -94.06 -68.906 -93.16 L -38.906 -77.96 C -36.906 -76.96 -33.506 -77.36 -31.606 -78.36 L -3.306 -92.76 C -2.106 -93.36 -0.606 -94.66 -2.506 -95.56 L -32.506 -110.76 C -34.406 -111.76 -37.906 -111.36 -39.806 -110.36 Z"
            fill="url(#paint0_linear_25_18)"
            style=""></path>
          <animateMotion
            id="right"
            begin="0.41s; right.end + 0.5s"
            repeatCount="1"
            path="M 0 0 L 0.429 23.971"
            calcMode="linear"
            dur="0.16s"
            fill="freeze"
            keyTimes="0; 0.5459; 1"
            keyPoints="0; 0.472756; 0"></animateMotion>
          <animate
            attributeName="opacity"
            values="1; 1"
            begin="1.38s"
            dur="0.05s"
            fill="freeze"></animate>
        </g>
      </g>
    </g>
  </svg>
</div>
